export const SCHEMA_VERSION = '1.7.0';
